import { render } from "./FileReader.vue?vue&type=template&id=67622f14"
import script from "./FileReader.vue?vue&type=script&lang=js"
export * from "./FileReader.vue?vue&type=script&lang=js"
script.render = render

export default script